import { getApiUrl } from "src/app/core/utils/Constants";

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  production: false,
  apiUrl: '' // Esta propiedad se actualizará con la URL de la API cargada desde el archivo JSON
};

getApiUrl().then(apiUrl => {
  environment.apiUrl = apiUrl;
}).catch(error => {
  console.error('Error obteniendo la API URL:', error);
});
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
